import React, { Ref } from 'react';

import { RadioButtons, radioErrorMessage } from '../../components/radio-buttons/radio-buttons';
import { RadioType, SvarId } from '../../types/generated-types';
import { FocusableHtmlElement } from '../hooks';
import { RadioFeilmelding, toOptions } from '../radio/radio';
import { updateSkadelidtInfoHasBankIdandMobilSvar } from '../reducer/sporsmalsflyt-actions';
import { RadioAlternativ } from '../reducer/sporsmalsflyt-types';
import { useSporsmalsflytDispatch } from '../reducer/sporsmalsflytDispatchProvider';
import { CurrentSkadelidtInfoSporsmal } from './skadelidtInfo-types';

import './skadelidt-bank-id-og-mobil.scss';

interface Props {
    currentSporsmal: CurrentSkadelidtInfoSporsmal;
    showFeilmeldinger: boolean;
    focusOnMount: boolean;
    errorRef?: Ref<FocusableHtmlElement>;
}

const optionJa = SvarId.JaEllerNei_Alternativ_Ja;
const optionJaText = 'Ja';

const optionNei = SvarId.JaEllerNei_Alternativ_Nei;
const optionNeiText = 'Nei';

const alternative: RadioAlternativ[] = [
    {
        id: optionJa,
        tekst: optionJaText,
    },
    {
        id: optionNei,
        tekst: optionNeiText,
    },
];

export const SkadelidtInfoBankIdOgMobil = ({
    currentSporsmal,
    showFeilmeldinger,
    errorRef,
    focusOnMount = true,
}: Props) => {
    const dispatch = useSporsmalsflytDispatch();
    const { hasBankIdOgMobil } = currentSporsmal.sporsmal.skadelidtInfoSporsmalFieldLabels;

    const onRadioChange = (value: string) => {
        dispatch(updateSkadelidtInfoHasBankIdandMobilSvar(value === optionJa));
    };

    const selectedOption = (): SvarId => {
        switch (currentSporsmal.hasBankIdOgMobil) {
            case null:
                return null;
            case true:
                return optionJa;
            default:
                return optionNei;
        }
    };

    return (
        <div className="skadelidt--radio-btn ">
            <RadioButtons
                name="har-mobil-og-bankid"
                label={hasBankIdOgMobil}
                options={toOptions(alternative, undefined, 'har-mobil-og-bankid')}
                selectedOption={selectedOption()}
                onChange={onRadioChange}
                errorMessage={radioErrorMessage(showFeilmeldinger, selectedOption())}
                focusOnMount={focusOnMount}
                errorRef={errorRef}
                key={`radio-sporsmal-${currentSporsmal.sporsmal.id}`}
                radioType={RadioType.Toggles}
            />
            <RadioFeilmelding alternativer={alternative} selectedOptionId={selectedOption()} />
        </div>
    );
};
